import { Button, Input, Text } from '@chakra-ui/react';
import type { SubmitEvent } from 'react';
import { useState } from 'react';

import { axiosInstance } from '@/api/axiosInstance';
import { Alert, Link, RouterLink, VStack } from '@/components';

import { forgotPasswordCss } from './ForgotPassword.styles';

export const ForgotPassword = () => {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event: SubmitEvent) => {
    event.preventDefault();
    setError(null);
    setIsSubmitting(true);

    const form = event.currentTarget as HTMLFormElement;
    const formData = new FormData(form);
    const email = formData.get('email') as string;

    try {
      await axiosInstance.post('/auth/password-reset/', { email });
      setSubmitted(true);
    } catch {
      setError('Something went wrong. Please try again.');
      setIsSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <VStack className="ForgotPassword" css={forgotPasswordCss}>
        <Alert
          status="success"
          variant="solid"
          title="Check your email for a reset link."
        />
        <Button asChild colorPalette="accent" pill width="full">
          <RouterLink to="../login">Back to Login</RouterLink>
        </Button>
      </VStack>
    );
  }

  return (
    <VStack
      as="form"
      className="ForgotPassword"
      css={forgotPasswordCss}
      onSubmit={handleSubmit}
    >
      {error && <Alert status="error" variant="solid" title={error} />}

      <Text className="instructions" textStyle="sm">
        Enter your email address and we&apos;ll send you a link to reset your
        password.
      </Text>

      <Input
        name="email"
        placeholder="Email"
        type="email"
        autoComplete="username"
        required
      />

      <Button
        type="submit"
        colorPalette="accent"
        pill
        width="full"
        loading={isSubmitting}
      >
        Send reset link
      </Button>

      <Link to="../login" variant="underline" className="back-link">
        Back to Login
      </Link>
    </VStack>
  );
};
